import { render, staticRenderFns } from "./TvChannels.vue?vue&type=template&id=e8b253d4"
import script from "./TvChannels.vue?vue&type=script&lang=js"
export * from "./TvChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports